import React from "react";
import BasicModal from "../../_widgets/Modal/BasicModal";
import { Col, Form, Row } from "react-bootstrap";
import Input from "../../_widgets/Input/Input";
import { warn } from "../../../Wrapper/toast/toast";
import {
  MAX_10_CHARS,
  MAX_20_CHARS,
  MAX_30_CHARS,
  MAX_50_CHARS,
  PHONE_NUMBER_INCORRECT,
} from "../../../Constants/stringConstants";

const EditInventoryCategoryModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addInventoryData,
  addInventory,
  editInventory,
  buttonLoading,
  setAddInventoryData,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="md"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`${addInventoryData.action} Inventory Category`}
      footer
      button2Text="Save"
      button2Click={() =>
        addInventoryData.action === "Add" ? addInventory() : editInventory(addInventoryData.id)
      }
      loading={buttonLoading}
    >
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={12}>
                  <Input
                    placeholder="Enter Inventory Category Name"
                    type="text"
                    label="Inventory Category Name"
                    value={addInventoryData?.name}
                    onChange={(e) => {
                      if (e.target.value.length <= 30) {
                        setAddInventoryData({
                          ...addInventoryData,
                          name: e.target.value,
                        });
                      } else {
                        warn(MAX_30_CHARS);
                      }
                    }}
                  />
                </Col>
                <Col lg={12}>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter Description here"
                    rows={4}
                    value={addInventoryData.description}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setAddInventoryData({
                          ...addInventoryData,
                          description: e.target.value,
                        });
                      } else {
                        warn(MAX_50_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default EditInventoryCategoryModal;
